import { XCircle } from "@phosphor-icons/react"
import { Button, Toast } from "@vesatogo/grass-core"
import toast from "react-hot-toast"
import { useNavigate } from "react-router-dom"
import {
  useCloseDemandMutation,
  useCloseOfferMutation,
} from "~/generated/graphql"

export const QuickActionsCard = ({
  type,
  id,
  status,
}: {
  type: "demand" | "offer"
  id: string
  status?: string
}) => {
  const navigate = useNavigate()
  const [, closeDemand] = useCloseDemandMutation()
  const [, closeOffer] = useCloseOfferMutation()

  const closeHandler = () => {
    if (status === "closed") {
      return toast.custom(
        <Toast
          intent="info"
          title={`${
            type.charAt(0).toUpperCase() + type.slice(1)
          } is already closed`}
        />
      )
    }
    if (type === "demand") {
      closeDemand({
        where: {
          id: {
            _eq: id,
          },
        },
        set: {
          status: "closed",
        },
      })
    } else {
      closeOffer({
        id: id,
        status: "closed",
      })
    }
    toast.custom(
      <Toast title={`Closed ${type.charAt(0).toUpperCase() + type.slice(1)}`} />
    )
    navigate(-1)
  }
  return (
    <div className="bg-gray-100 border-1 border-gray-300 rounded-xl p-4 flex flex-col gap-4 mt-4 justify-end">
      <header className="flex items-center gap-2 border-b border-gray-50">
        <span className="font-500 text-gray-800">Quick Actions</span>
      </header>

      <div className="flex flex-col gap-3">
        <Button
          intent="danger"
          variant="outline"
          className="!w-full"
          size="sm"
          leftIcon={<XCircle size={20} />}
          onClick={closeHandler}
        >
          Close {type.charAt(0).toUpperCase() + type.slice(1)}
        </Button>
        <p className="text-xs text-red italic text-center">
          If required, you may manually trigger the action.
        </p>
      </div>
    </div>
  )
}
